import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher } from '@angular/router';
import { AmbassadorsComponent } from './pages/ambassadors/ambassadors.component';
import { CommissionPlansComponent } from './pages/commission-plans/commission-plans.component';
import { FaqComponent } from './pages/faq/faq.component';
import { AmbassadorAuthGuard } from './guards/ambassador-auth.guard';
import { HowItWorksComponent } from './pages/how-it-works/how-it-works.component';
import { MarketingResourcesComponent } from './pages/marketing-resources/marketing-resources.component';
import { WhoShouldJoinComponent } from './pages/who-should-join/who-should-join.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import portalPaths from '../config/portal-paths.json';

const exactPaths = (paths: readonly string[]): UrlMatcher => segments =>
  paths.includes('/' + segments.map(segment => segment.path).join('/')) ? { consumed: [] } : null;

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'ambassadors' },
  { path: 'ambassadors', component: AmbassadorsComponent },
  { path: 'how-it-works', component: HowItWorksComponent },
  { path: 'commission-plans', component: CommissionPlansComponent },
  { path: 'who-should-join', component: WhoShouldJoinComponent },
  { path: 'marketing-resources', component: MarketingResourcesComponent },
  { path: 'faq', component: FaqComponent },
  { matcher: exactPaths(['/login', '/signup', '/reset-password']), loadChildren: () => import('./account/account.module').then(module => module.AccountModule) },
  { matcher: exactPaths(portalPaths), canMatch: [AmbassadorAuthGuard], loadChildren: () => import('./portal/portal.module').then(module => module.PortalModule) },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
